


















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
// @ts-ignore
import store from "../../../store";

@Component({
    components: {},
    props: {}
})

export default class MinutesPicker extends Vue {
    private values = [1, 5, 10, 15, 20, 25];
    private currentValue = this.values[0];
    private listIsVisible = false;

    mounted(): void
    {
    }

    beforeDestroy(): void
    {
    }

    private changeValue(value: number): void
    {
        this.currentValue = value;
        this.toggleList();
    }

    private toggleList(): void
    {
        this.listIsVisible = !this.listIsVisible;
    }

    private addMinutes(): void
    {
        this.$emit('add-minutes', this.currentValue);
    }
}

